import { render, staticRenderFns } from "./FormInformationsFilm.vue?vue&type=template&id=95a0b520&"
import script from "./FormInformationsFilm.vue?vue&type=script&lang=js&"
export * from "./FormInformationsFilm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports